var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 53 53",
    style: {
      enableBackground: "new 0 0 53 53"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 28,
    style: {
      fill: "#424A60"
    },
    width: 2,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 2.893,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 20.8223 -23.2696)",
    style: {
      fill: "#424A60"
    },
    width: 2,
    height: 21.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 21.858,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 30.1421 -0.7696)",
    style: {
      fill: "#424A60"
    },
    width: 2,
    height: 28.284
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.722,
    y: 13.5,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 15.6716 -8.8345)",
    style: {
      fill: "#424A60"
    },
    width: 15.556,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.893,
    y: 32.5,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 34.6716 -16.7046)",
    style: {
      fill: "#424A60"
    },
    width: 21.213,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#43B05C"
    },
    cx: 48,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7383BF"
    },
    cx: 28,
    cy: 48,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#57D8AB"
    },
    cx: 5,
    cy: 46,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D75A4A"
    },
    cx: 12,
    cy: 8,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EBBA16"
    },
    cx: 44,
    cy: 40,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4B6DAA"
    },
    cx: 28,
    cy: 24,
    r: 7
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/red.8e5a852f42b5b8f3fef90761394b8c45.svg";
export { ForwardRef as ReactComponent };